<template>
  <v-container fluid>
    <base-material-card id="unitizacao-data-table-bmc" color="primary" icon="mdi-set-merge" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div id="title-unitizacao" class="display-2 font-weight-light">Unitização e Módulos ANEEL</div>
      </template>
      <v-btn
        id="btn-nova-unitizacao"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova Unitização
      </v-btn>
      <v-text-field
        id="unitizacoes-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Unitização" />
      <v-divider class="mt-10" />
      <v-data-table
        class="unitizacoes-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma unitização disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="text-truncate-column"
                :class="['EXECUTANDO', 'AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-on="on"
                @click="openModalAcompanhamento(item)"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.data_execucao`]="{ item }">
          {{ item.data_execucao }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-unitizacao"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-unitizacao"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-unitizacao"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarUnitizacao(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="excluirUnitizacao(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Unitização #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a unitização
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Unitização"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button" width="210px">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.parametro.indexOf('obra') == -1" class="button">
                {{ row.item.valor }}
              </td>
              <td v-else-if="row.item.valor.length == 0" class="button" />
              <td v-else-if="row.item.valor.length == 1" class="button">
                {{ row.item.valor[0] }}
              </td>
              <td v-else class="button" style="padding-left: 0px !important">
                <v-textarea
                  rows="5"
                  no-resize
                  readonly
                  class="ml-4 mt-0 pt-0"
                  :value="$refs.dialogDetalhes.updateValueTextArea(row.item.valor)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-unitizacao-obras-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">Andamento da Unitização #{{ dialogAcompanhamentoData.id }}</template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
  import UnitizacoesObrasService from '@/services/UnitizacoesObrasService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados', 'recharge'],

    data() {
      return {
        powerupService: UnitizacoesObrasService,
        powerupEntityName: 'Unitizações_de_Obras',
        dialogDelete: false,
        dialogDeleteData: { id: undefined, nome: undefined },
        dialogDetalhes: false,
        dialogDetalhesData: [],
        dialogDetalhesHeader: [
          { text: 'Resumo', value: 'parametro', sortable: false },
          { text: '', value: 'valor', sortable: false }
        ],
        dialogAcompanhamento: false,
        dialogAcompanhamentoData: { id: undefined, andamento: [] },
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'data_execucao'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        unitizacoes: [],
        downloadProgressData: {}
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      executarUnitizacao(id) {
        UnitizacoesObrasService.executarUnitizacao(id, this.user.uid)
          .then(() => {
            this.$toast.success('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao executar unitização.', '', { position: 'topRight' });
          });
      },

      excluirUnitizacao(id) {
        UnitizacoesObrasService.excluirUnitizacao(id, this.user.uid)
          .then(() => {
            this.$toast.success('Unitização excluida com sucesso.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao excluir unitização.', '', { position: 'topRight' });
          });

        this.dialogDelete = false;
      },

      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      },

      openDialogDetalhes(unitizacao) {
        let textColumnObras = unitizacao.obras.length == 0 || unitizacao.obras.length > 1 ? ' obras:' : ' obra:';

        this.dialogDetalhesData = [
          {
            parametro: 'Nome:',
            valor: unitizacao.nome
          },
          {
            parametro: unitizacao.obras.length + textColumnObras,
            valor: unitizacao.obras
          },
          {
            parametro: 'Data para aplicação dos Módulos ANEEL:',
            valor: unitizacao.data_aplicacao_modulos_aneel
          },
          {
            parametro: 'Unitizar por:',
            valor: unitizacao.unitizar_por
          },
          {
            parametro: 'Quantidade mínima de cabo para ser UAR:',
            valor: unitizacao.qtd_minima_cabo_uar
          },
          {
            parametro: 'Ratear COM e CA Específico para TUC?	:',
            valor: unitizacao.ratear_com_ca_especifico == 0 ? 'Não' : 'Sim'
          }
        ];

        this.dialogDetalhes = true;
      },

      openModalAcompanhamento(unitizacao) {
        if (!['EXECUTANDO', 'AGUARDANDO'].includes(unitizacao.status)) {
          return;
        }
        this.dialogAcompanhamentoData.id = unitizacao.id;
        this.dialogAcompanhamento = true;

        this.attAndamentoUnitizacao(unitizacao.id);
      },

      attAndamentoUnitizacao(id) {
        UnitizacoesObrasService.andamento(id)
          .then((response) => {
            this.dialogAcompanhamentoData.andamento = response.data.andamento;
            this.$refs.dialogAcompanhamento.activatePusher();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar andamento da unitização.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .unitizacoes-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .unitizacoes-table table tr td:nth-child(5),
    .unitizacoes-table table tr td:nth-child(6) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 500px) {
    #title-unitizacao {
      font-size: 1.4em !important;
    }
  }

  #unitizacao-data-table-bmc .mdi-set-merge {
    font-size: 40px !important;
  }

  #unitizacao-data-table-bmc .v-card--material__heading {
    padding: 12px !important;
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>